// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--dialog-card-text-padding:0 24px}@media only screen and (max-width:701px){:root{--dialog-card-text-padding:0 16px}}.theme--light.v-radio--is-disabled label{color:rgba(15,23,42,.38)}.theme--dark.v-radio--is-disabled label{color:rgba(248,250,252,.5)}.v-radio{align-items:center;display:flex;height:auto;outline:none}.v-radio--is-disabled{cursor:default;pointer-events:none}.v-input--radio-group.v-input--radio-group--row .v-radio{margin-right:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
